import { ICON_ART } from "../data/iconArt";

/* ===========================================================================
   Flat SVG renderer for the five symbolic icons, drawn from the reference
   site's own path data in `iconArt.js`. The same data drives the extruded 3D
   models, so the flat and solid versions can never drift apart.

   The `st0 / st1 / st2` classes carry the original three-tone fill (pale blue,
   brand blue, amber) and are coloured from CSS.
   =========================================================================== */

const TONE_CLASS = { pale: "st0", blue: "st1", amber: "st2" };

export default function FlatIcon({ name, ...props }) {
  const art = ICON_ART[name];
  if (!art) return null;

  const [width, height] = art.viewBox;

  return (
    <svg viewBox={`0 0 ${width} ${height}`} aria-hidden="true" {...props}>
      {art.parts.map((part, i) => (
        <path key={`${name}-${i}`} className={TONE_CLASS[part.tone]} d={part.d} />
      ))}
    </svg>
  );
}
